module.exports = __webpack_public_path__ + "img/8.a61bc536.png";